import * as React from 'react';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { isMobileLayout as isMobileSelector } from 'components/Shared/responsive';
import { NO_ELEMENT, rm } from 'utils';
import cn from 'classnames';
import { selectPhoneOpen } from 'components/Footer/selector';

interface SectionProps {
  title?: string;
}

interface TextSectionProps extends SectionProps {
  texts?: string[];
  hide?: boolean;
  smallTitle?: boolean;
}

const TextSection = ({ title = '', texts = [], hide, smallTitle }: TextSectionProps) => {
  if (hide) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.contactTextContainer}>
      <p
        className={cn(styles.contactTitle, {
          [styles.contactText]: smallTitle
        })}
      >
        {title}
      </p>
      {texts.map((text: string, index: number) => (
        <p key={index} className={styles.contactText}>
          {text}
        </p>
      ))}
    </div>
  );
};

export const Section = ({ title }: SectionProps) => {
  const isMobile = useSelector(isMobileSelector);
  const phoneOpen = useSelector(selectPhoneOpen);

  return (
    <div className={styles.contactSection}>
      {!isMobile && (
        <TextSection title={rm('footer_contact_heading')} texts={[rm('footer_contact_text')]} />
      )}
      {!isMobile && <TextSection smallTitle title={title} texts={[phoneOpen ?? '']} />}
    </div>
  );
};
